import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import CompanyOdsEquipment from "../child/company-ods-equipment";

const ViewCompanyEquipContainingLog = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fd = new FormData();
    fd.append("ods_id", id);

    post(ApiURL.company_view_ods_record, fd).then((res) => {
      if (res?.status) setDetails(Array.isArray(res.data) ? res.data[0] : res.data);
    });
  }, [id]);

  if (!details) return <h3>Loading...</h3>;

  return (
    <>
      <h2>View Equip Containing Log</h2>
      <CompanyOdsEquipment equipmentDetails={details} />
    </>
  );
};

export default ViewCompanyEquipContainingLog;
